import React, {Component} from 'react';
import OrderItem from './OrderItem';
import classes from './FullBox.css';

export default class FullBox extends Component {
    render() {

        return (
            <div className="block not-padded top-padded">
                <h3 className="custom-mb-0 custom-mt-16">Коробка #{this.props.boxNumber}</h3>
                <table className="zebra">
                    <thead>
                    <tr>
                        <th>Товар</th>
                        <th>Количество</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.box.items.map((item, i) => (
                        <tr key={i} className={classes.fullBoxItem}>
                            <td className={classes.fullBoxItem__info}>
                                <OrderItem item={item.item} />
                            </td>
                            <td className="nowrap">
                                × {item.fullCount}
                            </td>
                            <td className="nowrap">
                                {window.ui_version == 2 ? (
                                    <a
                                        href="#"
                                        onClick={e => {
                                            e.preventDefault();
                                            this.props.onRemoveItem(item);
                                        }}
                                    >
                                        <i className="fas fa-redo-alt custom-mr-4" />
                                        Убрать из коробки
                                    </a>
                                ) : (
                                    <ul className="menu-h">
                                        <li>
                                            <a
                                                href="#"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.props.onRemoveItem(item);
                                                }}
                                            >
                                            <i className="icon16 update" />
                                                Убрать из коробки
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}